import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchQueryChangeLogs = async ({ page, patientId, trialId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  params.append("page", page);
  params.append("patient_id", patientId);
  params.append("trial_id", trialId);

  const response = await axios.get(
    `${__API_URL__}/api/ecrf/get_query_change_logs/?${params.toString()}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useGetQueryChangeLogs = ({ page = 1, patientId, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["query_change_logs", patientId, page, trialId],
    queryFn: () => fetchQueryChangeLogs({ page, patientId, trialId }),
    enabled: enabled && Boolean(patientId) && Boolean(trialId),
    keepPreviousData: true,
  });
};

export default useGetQueryChangeLogs;
